var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.236,
    height: 19.599,
    viewBox: "0 0 18.236 19.599",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bill-check-svgrepo-com",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7270",
    "data-name": "Path 7270",
    d: "M15.789,2H6.947A7,7,0,0,0,4.9,2.146,2.784,2.784,0,0,0,3.147,3.89,6.927,6.927,0,0,0,3,5.933v12.6a.9.9,0,0,0,1.5.669.9.9,0,0,1,1.194,0l.449.4a1.579,1.579,0,0,0,2.092,0,1.579,1.579,0,0,1,2.092,0,1.579,1.579,0,0,0,2.092,0,1.579,1.579,0,0,1,2.092,0,1.579,1.579,0,0,0,2.092,0l.449-.4a.9.9,0,0,1,1.194,0,.9.9,0,0,0,1.5-.669V5.933a6.925,6.925,0,0,0-.147-2.044A2.784,2.784,0,0,0,17.84,2.146,7,7,0,0,0,15.789,2Z",
    transform: "translate(-3 -2)",
    fill: "none",
    stroke: "#9facbe",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7271",
    "data-name": "Path 7271",
    d: "M9.5,10.4,10.929,12,14.5,8",
    transform: "translate(-3.632 -2.75)",
    fill: "none",
    stroke: "#9facbe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7272",
    "data-name": "Path 7272",
    d: "M7.5,15.5h9",
    transform: "translate(-3.632 -3.35)",
    fill: "none",
    stroke: "#9facbe",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.caf778d39d38a72a0185c2f9054e7e2d.svg";
export { ForwardRef as ReactComponent };